export default function H1({ title, fontWeight = 'bold', theme = "title", className = "" }) {
    return (
        <h1 className={`text-1xl md:text-3xl font-${fontWeight} text-${theme} ${className}`}>
            {title}
        </h1>
    );
}
